import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ProductsOrdersService {
  private baseUrl: string = "/order-product";

  constructor(private _httpClient: HttpClient) {}

  async getOrders() {
    return this._httpClient.get(`${this.baseUrl}`).toPromise();
  }

  async getOrder(id: number) {
    return this._httpClient.get(`${this.baseUrl}/${id}`).toPromise();
  }

  async addOrder(data: any = {}) {
    return this._httpClient.post(`${this.baseUrl}`, data).toPromise();
  }

  async editOrder(id: number, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/${id}`, data).toPromise();
  }

  async deleteOrder(id: number) {
    return this._httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  async uploadDocument(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/order-product/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async uploadAttachment(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/order-product/upload/attachment/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async deleteDocument(id: number) {
    return this._httpClient.delete("/order-product/file/" + id).toPromise();
  }

  async deleteAttachment(id: number) {
    return this._httpClient.delete("/order-product/attachment/" + id).toPromise();
  }

  async manageApproval(id: number, data: any = {}) {
    return this._httpClient.put("/order-product/approval/" + id, data).toPromise();
  }

  manageStatusOrder(id: number, data: any = {}) {
    return this._httpClient.put("/order-product/status/" + id, data).toPromise();
  }
}
